import React, { useRef } from 'react'
import { useParams } from 'react-router-dom';
import {FaClone} from "react-icons/fa"
import { cuteToast } from '../../UI/cute';

const CopyLinkModals = () => {

    const {camp_id} = useParams();

    const ref = useRef()
    const anchorLink = `https://vidcraftai.vidconnect.net/page/${camp_id}`;

    const handleCopy = (e) =>{
        /* Get the text field */
        var copyText = anchorLink
        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText);

        ref.current.click();

        cuteToast({
            type: "success",
            message: "Url copied successfully.",
            timer: 5000,
            title: "Copy Link",
        });

    }

    return (
        <>
            <div className="modal popup2" id="myModal3">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Share the link with thumbnail</h4>
                            <button ref={ref} type="button" className="btn_close2" data-bs-dismiss="modal">
                                <i className="fa fa-close"></i>
                            </button>
                        </div>

                        <div className="modal-body p-5">
                            <div className="row">
                                <div className="col-xl-11 col-lg-12 col-md-12 m-auto">
                                    <form>
                                        <h5>Share the link with thumbnail</h5>
                                        <p>Lorem ipsum is a placeholder text commonly  to demonstrate the visual form of a document typeface without relying on meaningful.</p>
                                        <input name="" type="text" placeholder="Email*" className="form-control textbx2 mb-3 shadow-none" />
                                        <input name="" type="text" placeholder="First Name*" className="form-control textbx2 mb-3 shadow-none" />
                                        <button 
                                            type="button" 
                                            className="btn1 copylinkbtn border-0 rounded-1 w-100 position-relative"
                                            onClick={handleCopy}
                                        >
                                            <FaClone className='me-1' /> Copy Link with Thumbnail <i className="fa fa-caret-down"></i></button>

                                    </form>


                                </div>


                            </div>


                        </div>



                    </div>
                </div>
            </div>
        </>
    )
}

export default CopyLinkModals